import { render, staticRenderFns } from "./catCard.vue?vue&type=template&id=ae5dce2e&scoped=true"
import script from "./catCard.vue?vue&type=script&lang=js"
export * from "./catCard.vue?vue&type=script&lang=js"
import style0 from "./catCard.vue?vue&type=style&index=0&id=ae5dce2e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae5dce2e",
  null
  
)

export default component.exports